// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shadow":"shadow_FPu+x","ui_mask":"ui_mask_RkWox"};